import {
  BrowserRouter as Router,
  Switch,
  Route,
  NavLink,
  Redirect
} from "react-router-dom";
import React  from "react";
import Application from "./Components/Application";
import UserProvider from "./providers/UserProvider";

import { useState } from 'react';


function App() {

  return (


 
	    <Router>
	      	<div className="flex border md:flex-row md:items-start border-blue-400 px-3 py-4" style={{backgroundColor: "#FFFFFF"}}>
		      	<div className="flex border md:flex-row md:items-start border-blue-400 px-3 py-4" style={{backgroundColor: "#FFFFFF"}}>
		        	<NavLink to='/home'>
			           My Recipe Recommendations
		        	</NavLink>
		      	</div>
		      	<div className="flex border md:flex-row md:items-start border-blue-400 px-3 py-4" style={{backgroundColor: "#FFFFFF"}}>
		        	<NavLink to='/liked'>
				           My Liked Recipes
		        	</NavLink>
		      	</div>
				<div className="flex border md:flex-row md:items-start border-blue-400 px-3 py-4" style={{backgroundColor: "#FFFFFF"}}>
					<NavLink to="about">About</NavLink>  
				</div>
	 	  	</div>
	    	<Switch>
	          	<Route path="/about">
	          		<div style={{ backgroundImage: "url(/pineapple.jpg)", height:"100vh", minHeight:"100%", position:"relative", backgroundSize:"cover"}}>
		            	<div className = "mx-auto w-11/12 md:w-2/4 py-8 px-4 md:px-8">
		      				<div className="flex border flex-col items-center md:flex-row md:items-start border-blue-400 px-3 py-4" style={{backgroundColor: "#FFFFFF"}}>

								Filippos, Irene, Mariam, and Anchit started FIMA (Food Ingredients Made Appetizing) because they wanted to help college students, or others who are interested in home cooking , explore a culinary world in the comfort of their own home. That’s why they created this website to recommend recipes to you based on your dietary preferences, ingredient preferences, and flavor profile. Along the way, you will also be able to explore recipes outside of your flavor profile, and try out new cuisines. FIMA wants you to be able to conserve time, money, and energy, while eliminating food waste by providing you with the exact ingredients and cooking time required at the click of a button, personalized to just for you.  
		      				</div>
		     			 </div>
	     			 </div>
	          	</Route>
				<Route path="/home">
					<div style={{ backgroundImage: "url(/bread.jpeg)", height:"100%"}}>
						<Fima />
					</div>
	          	</Route>
	          	<Route path="/liked">
	          		<div style={{ backgroundImage: "url(/grapefruit.jpg)", height:"100%"}}>
			    		<FimaLiked />
		    		</div>	
	          	</Route>
	          	<Redirect to="/home" />
	        </Switch>
	    </Router>
  );
}


function Fima() {
	  return (
    <UserProvider>
      <Application />
    </UserProvider>

  );
}

function FimaLiked() {
	  return (
    <UserProvider>
      <Application liked={true}/>
    </UserProvider>

  );
}

export default App;
